import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, target: String }

  open() {
    const modalId = this.targetValue || this.idValue
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.remove('hidden')
      document.body.style.overflow = 'hidden'
    }
  }

  close() {
    const modal = this.element.closest('[id]')
    if (modal) {
      modal.classList.add('hidden')
      document.body.style.overflow = ''
    }
  }

  // Close on escape key
  closeOnEsc(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
